<template>
  <div class="newsfeed">
    <b-carousel animated="slide" :interval="6000" :indicator="false">
      <b-carousel-item v-for="(carousel, i) in newsfeeds" :key="i">
        <section :class="`hero is-small`">
          <div class="newsfeed__item">
            <p class="mb-2 has-text-weight-bold	">
              Congratulations on achieving a new level!
            </p>
            <ProfileCard
              :player="carousel.player"
              :level="carousel.level"
              type="medium"
              color="white"
              :isSquared="true"
              :challenge="true"
            />
            <p class="is-size-7 is-italic">
              {{ carousel.createdAt | distanceFromNow }}
            </p>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";

export default {
  components: { ProfileCard },

  // props: ["onlinePlayers"],

  data() {
    return {
      newsfeeds: null,
    };
  },

  methods: {
    queryNewsfeed() {
      const body = new URLSearchParams();
      body.append("methodName", "get_chess_ratings_news_feed");

      const options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body,
      };

      fetch(
        "https://www.chesssquad.com/api/backend-azure-table-method-call.php",
        options
      )
        .then((response) => response.json())
        .then(
          (data) =>
            (this.newsfeeds = data.map((entry) => ({
              level: parseInt(entry.RatingLevel),
              player: {
                first_name: entry.FirstName,
                username: entry.Username,
                dna: entry.DNA,
                school: { school_name: entry.SchoolName },
              },
              createdAt: new Date(entry.Created * 1000),
            })))
        )
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  },

  created() {
    this.queryNewsfeed();
  },
};
</script>

<style scoped>
.newsfeed__item {
  align-self: center;
  border: 2px solid #0074dd;
  border-radius: 10px;
  color: white;
  background-color: #0074dd;
  padding: 3px 15px;
  min-width: 350px;
}
</style>
